import React from "react";
import { Link } from "react-router-dom";
import { Bell, MessageCircle, ArrowRight } from "lucide-react";
import { WHATSAPP_URL, INTEREST_HREF } from "../lib/constants";
import { trackNotifyClick, trackWhatsAppClick } from "../lib/track";

/**
 * Interest-list CTA: sends people to the interest form on the homepage. While
 * Bhaav Sangam is on sale, booking lives in components/Shows.jsx; this is for
 * the cities those shows do not reach.
 *
 * `tone` = "light" (default) or "dark" for the supporting text colour.
 * `note` renders an optional line under the button.
 */
export function InterestCta({ className = "", note, tone = "light" }) {
  const sub = tone === "dark" ? "text-[#E8D9C5]" : "text-ink-2/75";
  return (
    <div className={`flex flex-col items-center ${className}`}>
      <a
        href={INTEREST_HREF}
        onClick={trackNotifyClick}
        className="cta-primary"
        data-testid="interest-cta"
      >
        <Bell size={18} />
        <span>Tell us your city</span>
        <span className="cta-arrow">→</span>
      </a>
      <p className={`mt-3 font-body text-sm font-medium ${tone === "dark" ? "text-[#E5C880]" : "text-amber"}`}>
        We'll let you know when Antara comes to you
      </p>
      {note && <p className={`mt-1 font-body text-sm ${sub}`}>{note}</p>}
      {/* Secondary, lower-emphasis WhatsApp */}
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={trackWhatsAppClick}
        className={`mt-4 inline-flex items-center gap-1.5 font-body text-sm ${sub} hover:opacity-80 transition`}
        data-testid="book-whatsapp"
      >
        <MessageCircle size={14} /> A question? WhatsApp
      </a>
    </div>
  );
}

// Inline text link (on light grounds)
export function TextLink({ to, href, children }) {
  const cls = "text-amber underline underline-offset-4 decoration-gold/50 hover:text-gold transition";
  if (to) return <Link to={to} className={cls}>{children}</Link>;
  return <a href={href} target="_blank" rel="noopener noreferrer" className={cls}>{children}</a>;
}

// "More" arrow link
export function MoreLink({ to, children }) {
  return (
    <Link to={to} className="inline-flex items-center gap-2 font-body text-sm tracking-wide text-amber hover:text-gold transition">
      {children} <ArrowRight size={15} />
    </Link>
  );
}
